import React from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import history from '@/utils/history';
import Loding from '@/components/Loading';
import VConsole from 'vconsole';
import AppConsts from './lib/appconst';
import { useEffect } from 'react';

if (process.env.REACT_APP_ENV !== 'prod') {
  const vConsole = new VConsole();
}
// 路由懒加载
const Login = React.lazy(() => import('@/scenes/Login'));
const Home = React.lazy(() => import('@/scenes/Home'));
const NotFound = React.lazy(() => import('@/scenes/NotFound'));

export default function App() {
  useEffect(() => {
    const link = document.createElement('link');
    link.setAttribute('rel', 'icon');
    link.setAttribute('href', `${AppConsts.baseURL}/logo.png`);
    document.head.appendChild(link);
    const linkIos = document.createElement('link');
    linkIos.setAttribute('rel', 'apple-touch-icon');
    linkIos.setAttribute('href', `${AppConsts.baseURL}/logo.png`);
    document.head.appendChild(linkIos);
  }, []);
  return (
    <>
      <Router history={history}>
        <React.Suspense fallback={<Loding />}>
          <Switch>
            <Redirect from="/" to="/login" exact />
            <Route path="/login" component={Login}></Route>
            <Route path="/home" component={Home}></Route>
            <Route component={NotFound} />
          </Switch>
        </React.Suspense>
      </Router>
    </>
  );
}
